import { IncludeType } from '../../../common';
import { ProductWithAttributes } from '../../models';
import { productCatalogueHttp } from '../product-catalogue-api';

/**
 * Fetches family attributes for a given family ID and locale.
 *
 * @param familyId - The ID of the family to fetch attributes for.
 * @param locale - The locale to use when fetching data.
 * @param includeType - Specifies the type of attributes to include (default is `IncludeType.Available`).
 * @returns A promise that resolves to an array of `ProductWithAttributes`, or `null` if none exist.
 */
export const getFamilyAttributes = async (
  familyId: number,
  locale: string,
  includeType: IncludeType = IncludeType.Available
): Promise<ProductWithAttributes[] | null> => {
  try {
    const url = `/family/${familyId}/attributes?include=${encodeURIComponent(includeType)}&marketLocale=${encodeURIComponent(locale)}`;
    const response = await productCatalogueHttp.get<ProductWithAttributes[]>(url);

    return response?.data ?? null;
  } catch (error) {
    console.error(`Failed to fetch family attributes for familyId: ${familyId}`, error);
    return null;
  }
};
